import { Settings } from "./Settings";
import {
    ICheckOptions,
    IReelTeasingAttributes,
    ISymbolTeasingAttributes,
    ReelTeasingActions,
    SymbolTeasingActions,
    TeasingComponent,
} from "./TeasingComponent";
import { PlayList } from "../Components/Sounds/PlayList";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { ModuleManager } from "../Managers/ModuleManager";
import { Tweens } from "../Components/Effects/Tweens";

export class TeasingBonus extends TeasingComponent {
    _impactScatterCounter: number;
    _stopScatterCounter: number;

    private _delayedTeasingFaildSound: FrameTimerEventEmitter;

    private _wildTimer: FrameTimerEventEmitter;
    private _delayedOutro: FrameTimerEventEmitter;
    private _delayedWindAnimation: FrameTimerEventEmitter;

    private running: boolean = false;

    constructor() {
        super();

        this.minimumSymbolsForTeasing = 2;

        this.teasingSymbol = Settings.SymbolTeasing;
        this.impactSymbols = Settings.SymbolsImpact;

        this._impactScatterCounter = 0;
        this._stopScatterCounter = 0;

        this._delayedTeasingFaildSound = CreateFrameTimer("delayedTeasingFaildSound");
        this._delayedTeasingFaildSound.on(FrameTimerEvents.Complete, this.delayedTeasingFaildSound.bind(this));

        this._wildTimer = CreateFrameTimer("teasingWildTimer");
        this._wildTimer.on(FrameTimerEvents.Complete, this.animateWilds.bind(this));

        this._delayedOutro = CreateFrameTimer("delayedOutroTimer");
        this._delayedOutro.on(FrameTimerEvents.Complete, this.outro.bind(this));

        this._delayedWindAnimation = CreateFrameTimer("delayedWindAnimation");
        this._delayedWindAnimation.on(FrameTimerEvents.Complete, this.delayedWindAnimation.bind(this));
    }

    set customData(value: any) {}

    public spinStart(): void {
        this.outro();

        if (this.wildPositions) {
            this.wildPositions.forEach((wilds) => {
                if (this.elementInstance["expandingWildReel" + wilds[0]].hasCase("HIDE")) {
                    this.elementInstance["expandingWildReel" + wilds[0]].goToCase("HIDE");
                }
            });
        }
    }

    public hideExpandingWilds() {
        if (this.wildPositions) {
            this.wildPositions.forEach((wilds) => {
                if (this.elementInstance["expandingWildReel" + wilds[0]].hasCase("HIDE")) {
                    this.elementInstance["expandingWildReel" + wilds[0]].goToCase("HIDE");
                }
            });
        }

        this.wildPositions = [];
    }

    private outro(force: boolean = false): void {
        if (this.running) {
            this._wildTimer.stop();
            this._delayedOutro.stop();
            if (this.wildPositions.length && this.elementInstance["teasingFront"] != null) {
                if (force && this.elementInstance["teasingFront"].hasCase("OUTRO_QUICK")) {
                    this.elementInstance["teasingFront"].goToCase("OUTRO_QUICK");
                } else if (this.elementInstance["teasingFront"].hasCase("OUTRO")) {
                    this.elementInstance["teasingFront"].goToCase("OUTRO");
                }
            } /*
            if (this.wildPositions.length && this.elementInstance['expandingWildMask'] != null) {
                if(this.elementInstance['expandingWildMask'].hasCase("HIDE")) {
                    this.elementInstance['expandingWildMask'].goToCase("HIDE");
                }
            }*/
            this.running = false;
        }
    }

    //******************************************************************************************************************
    //  CHECK REELS
    //******************************************************************************************************************

    /**
     * Check called before reel.spinStop(). Checks if teasing is possible and checks which reel can be stopped immediately.
     * @param {ICheckOptions} options
     */
    public checkOnInit(options: ICheckOptions, isFS: boolean): Array<IReelTeasingAttributes> {
        if (this.running) {
            if (options.force) {
                this.outro(true);
            }
            return this.reelsTeasingAttributes;
        }

        this.stoppedSymbolsArray = options.stoppedSymbols;
        this.force = options.force;
        let additionalDelay = 0;

        this.teasingEnabled = false;
        this.teasingEnabledForce = false;

        this.wildPositions = [];
        for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
            if (this.stoppedSymbolsArray[reelIndex].transform) {
                for (
                    let symbolIndex = 0;
                    symbolIndex < this.stoppedSymbolsArray[reelIndex].transform.length;
                    symbolIndex++
                ) {
                    if (
                        this.stoppedSymbolsArray[reelIndex].transform[symbolIndex] != -1 &&
                        this.stoppedSymbolsArray[reelIndex].transform[symbolIndex] === Settings.SymbolWild
                    ) {
                        this.wildPositions.push([reelIndex, symbolIndex]);
                        break;
                    }
                }
            }
        }

        if (this.wildPositions.length > 0) {
            this.running = true;
            if (!options.force) {
                this.teasingEnabled = true;
            } else {
                this.teasingEnabledForce = true;
            }

            let reelStopDelay = 0;
            for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
                additionalDelay += this.teasingStopDelay;
                this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.TEASE;
                this.reelsTeasingAttributes[reelIndex].stopDelay =
                    this.getExpandingWildIntroDelay() +
                    (this.wildPositions.length - 1) * this.getExpandingWildStartDelay() +
                    this.getCountAdditionalReelsDelay() +
                    this.getExpandingWildOutroDelay();

                this.reelsTeasingAttributes[reelIndex].stopDelay += reelStopDelay;

                if (this.hasReelExpandingWild(reelIndex) === -1) {
                    reelStopDelay += this.stopDelay;
                }
            }

            // shuffle this.wildPositions array
            for (let i = this.wildPositions.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [this.wildPositions[i], this.wildPositions[j]] = [this.wildPositions[j], this.wildPositions[i]];
            }

            this.wildIndex = 0;
            if (this.elementInstance["expandingWildMask"] != null) {
                if (isFS) {
                    this.elementInstance["expandingWildMask"].goToCase("SHOW_AUTO_HIDE_FS");
                } else {
                    this.elementInstance["expandingWildMask"].goToCase("SHOW_AUTO_HIDE");
                }
            }

            this._wildTimer.stop();
            this._wildTimer.start(this.getExpandingWildIntroDelay());
        } else {
            for (let reelIndex = 0; reelIndex < this.reelCount; reelIndex++) {
                if (
                    (this.precedingReelsWithSymbols(reelIndex, this.teasingSymbol) >= 2 &&
                        reelIndex > 1 &&
                        reelIndex < this.reelCount - 1) ||
                    (this.countSymbols(0, reelIndex - 1, this.teasingSymbol) >= 2 &&
                        reelIndex === this.reelCount - 1 &&
                        this.precedingReelsWithSymbols(reelIndex + 1, this.teasingSymbol) >= 2)
                ) {
                    if (!options.force) {
                        this.teasingEnabled = true;
                    } else {
                        this.teasingEnabledForce = true;
                    }
                    additionalDelay += this.teasingStopDelay;
                    this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.TEASE;
                } else {
                    this.reelsTeasingAttributes[reelIndex].action = ReelTeasingActions.SPIN_STOP;
                }
                this.reelsTeasingAttributes[reelIndex].stopDelay = reelIndex * this.stopDelay + additionalDelay;
            }
        }

        return this.reelsTeasingAttributes;
    }

    private getCountAdditionalReelsDelay(): number {
        let count = 0;
        for (let i = 0; i < this.expandingAdditionReelDelay.length; i++) {
            count += this.expandingAdditionReelDelay[i];
        }
        return count;
    }

    private animateWilds(): void {
        if (!this.wildPositions.length) {
            /*
            if(this.elementInstance['teasingWilds'].hasCase("RESET")) {
                this.elementInstance['teasingWilds'].goToCase("RESET");
            }*/
        } else {
            if (this.wildIndex < this.wildPositions.length) {
                let index = this.wildPositions[this.wildIndex][0];
                // if(this.elementInstance['expandingWildReel' + index].hasCase("SHOW")) {
                //     this.elementInstance['expandingWildReel' + index].goToCase("SHOW");
                // }
                if (ModuleManager.freespinsActive()) {
                    if (this.elementInstance["expandingWildReel" + index].hasCase("SHOW_DELAYED_FS")) {
                        this.elementInstance["expandingWildReel" + index].goToCase("SHOW_DELAYED_FS");
                    }
                    if (this.elementInstance["expandingWildMask"] != null) {
                        this.elementInstance["expandingWildMask"].goToCase("SHOW_AUTO_HIDE_FS_" + index);
                    }
                } else {
                    if (this.elementInstance["expandingWildReel" + index].hasCase("SHOW_DELAYED")) {
                        this.elementInstance["expandingWildReel" + index].goToCase("SHOW_DELAYED");
                    }
                    if (this.elementInstance["expandingWildMask"] != null) {
                        this.elementInstance["expandingWildMask"].goToCase("SHOW_AUTO_HIDE_" + index);
                    }

                    if (this.wildIndex < this.reelCount) {
                        this._delayedWindAnimation.stop();
                        this._delayedWindAnimation.start(
                            this.expandingAdditionReelDelay[index] + this.expandingWildWindDelay,
                        );
                    }
                }

                this.wildIndex++;
                this._wildTimer.stop();
                this._delayedOutro.stop();

                if (this.wildIndex >= this.wildPositions.length) {
                    this._delayedOutro.start(
                        this.getExpandingWildOutroDelay() + this.expandingAdditionReelDelay[index],
                    );
                } else {
                    this._wildTimer.start(this.getExpandingWildStartDelay() + this.expandingAdditionReelDelay[index]);
                }
            }
            // else {
            //     this.outro();
            // }
        }
    }

    private delayedWindAnimation(): void {
        if (this.elementInstance["background"] != null) {
            this.elementInstance["background"].goToCase("WILD_EXPECTATION");
        }

        if (this.elementInstance["foreground"] != null) {
            this.elementInstance["foreground"].goToCase("WILD_EXPECTATION");
        }

        let reelPositionY = 0;

        if (this.quality === "hd") {
            for (let i = 0; i < this.reelCount; i++) {
                if (this.elementInstance["expandingWildReel" + i] != null) {
                    reelPositionY = this.elementInstance["expandingWildReel" + i].position.y;
                    Tweens.positionTween(this.elementInstance["expandingWildReel" + i], {
                        tweenX: [0, -7, -5, -7, -5, -7, -5, -7, 0],
                        tweenY: [
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                        ],
                        tweenDuration: 220,
                        keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                    });
                }
            }

            if (this.elementInstance["machine"] != null) {
                reelPositionY = this.elementInstance["machine"].position.y;
                Tweens.positionTween(this.elementInstance["machine"], {
                    tweenX: [0, -7, -5, -7, -5, -7, -5, -7, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["noWinContainer"] != null) {
                reelPositionY = this.elementInstance["noWinContainer"].position.y;
                Tweens.positionTween(this.elementInstance["noWinContainer"], {
                    tweenX: [0, -7, -5, -7, -5, -7, -5, -7, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["winContainer"] != null) {
                reelPositionY = this.elementInstance["winContainer"].position.y;
                Tweens.positionTween(this.elementInstance["winContainer"], {
                    tweenX: [0, -7, -5, -7, -5, -7, -5, -7, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["reelsOver"] != null) {
                reelPositionY = this.elementInstance["reelsOver"].position.y;
                Tweens.positionTween(this.elementInstance["reelsOver"], {
                    tweenX: [0, -7, -5, -7, -5, -7, -5, -7, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }
        } else if (this.quality === "qhd") {
            for (let i = 0; i < this.reelCount; i++) {
                if (this.elementInstance["expandingWildReel" + i] != null) {
                    reelPositionY = this.elementInstance["expandingWildReel" + i].position.y;
                    Tweens.positionTween(this.elementInstance["expandingWildReel" + i], {
                        tweenX: [0, -5, -4, -5, -4, -5, -4, -5, 0],
                        tweenY: [
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                        ],
                        tweenDuration: 220,
                        keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                    });
                }
            }

            if (this.elementInstance["machine"] != null) {
                reelPositionY = this.elementInstance["machine"].position.y;
                Tweens.positionTween(this.elementInstance["machine"], {
                    tweenX: [0, -5, -4, -5, -4, -5, -4, -5, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["noWinContainer"] != null) {
                reelPositionY = this.elementInstance["noWinContainer"].position.y;
                Tweens.positionTween(this.elementInstance["noWinContainer"], {
                    tweenX: [0, -5, -4, -5, -4, -5, -4, -5, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["winContainer"] != null) {
                reelPositionY = this.elementInstance["winContainer"].position.y;
                Tweens.positionTween(this.elementInstance["winContainer"], {
                    tweenX: [0, -5, -4, -5, -4, -5, -4, -5, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["reelsOver"] != null) {
                reelPositionY = this.elementInstance["reelsOver"].position.y;
                Tweens.positionTween(this.elementInstance["reelsOver"], {
                    tweenX: [0, -5, -4, -5, -4, -5, -4, -5, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }
        } else {
            for (let i = 0; i < this.reelCount; i++) {
                if (this.elementInstance["expandingWildReel" + i] != null) {
                    reelPositionY = this.elementInstance["expandingWildReel" + i].position.y;
                    Tweens.positionTween(this.elementInstance["expandingWildReel" + i], {
                        tweenX: [0, -10, -8, -10, -8, -10, -8, -10, 0],
                        tweenY: [
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                            reelPositionY,
                        ],
                        tweenDuration: 220,
                        keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                    });
                }
            }

            if (this.elementInstance["machine"] != null) {
                reelPositionY = this.elementInstance["machine"].position.y;
                Tweens.positionTween(this.elementInstance["machine"], {
                    tweenX: [0, -10, -8, -10, -8, -10, -8, -10, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["noWinContainer"] != null) {
                reelPositionY = this.elementInstance["noWinContainer"].position.y;
                Tweens.positionTween(this.elementInstance["noWinContainer"], {
                    tweenX: [0, -10, -8, -10, -8, -10, -8, -10, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["winContainer"] != null) {
                reelPositionY = this.elementInstance["winContainer"].position.y;
                Tweens.positionTween(this.elementInstance["winContainer"], {
                    tweenX: [0, -10, -8, -10, -8, -10, -8, -10, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }

            if (this.elementInstance["reelsOver"] != null) {
                reelPositionY = this.elementInstance["reelsOver"].position.y;
                Tweens.positionTween(this.elementInstance["reelsOver"], {
                    tweenX: [0, -10, -8, -10, -8, -10, -8, -10, 0],
                    tweenY: [
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                        reelPositionY,
                    ],
                    tweenDuration: 220,
                    keyTimes: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 1],
                });
            }
        }
    }

    //******************************************************************************************************************
    //  CHECK SYMBOLS TEASING
    //******************************************************************************************************************

    /**
     *
     * @param {number} reelIndex
     * @returns {Array<ISymbolTeasingAttributes>}
     */
    public checkSymbolsPerReel(reelIndex: number, force: boolean): Array<Array<ISymbolTeasingAttributes>> {
        let preceding = this.precedingReelsWithSymbols(reelIndex + 1, this.teasingSymbol);

        for (let reelNo = reelIndex; reelNo >= 0; reelNo--) {
            for (let symbolNo = 0; symbolNo < this.stoppedSymbolsArray[reelNo].symbols.length; symbolNo++) {
                if (reelNo === reelIndex && this.wildPositions.length === 0) {
                    if (this.stoppedSymbolsArray[reelNo].symbols[symbolNo] === this.teasingSymbol) {
                        if (reelIndex - this._impactScatterCounter > 2) {
                            this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.IMPACT;
                        } else {
                            if (this._impactScatterCounter >= 1 && !force) {
                                this.symbolsTeasingAttributes[reelNo][symbolNo].action =
                                    SymbolTeasingActions.IMPACT_TEASE_SHINE;
                            } else {
                                this.symbolsTeasingAttributes[reelNo][symbolNo].action =
                                    SymbolTeasingActions.IMPACT_TEASE;
                            }
                            //PlayList.play('SND_BaseRotationEndScatter' + (this._impactScatterCounter));
                            PlayList.play("SND_BaseRotationEndScatter");
                        }

                        this._impactScatterCounter++;
                    } else {
                        if (reelIndex - preceding < 2 && preceding >= 2) {
                            this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.TEASING_NOWIN;
                        } else {
                            this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.IMPACT;
                        }
                    }
                } else {
                    if (
                        reelIndex - preceding < 2 &&
                        this._impactScatterCounter >= 2 &&
                        this.stoppedSymbolsArray[reelNo].symbols[symbolNo] === this.teasingSymbol
                    ) {
                        this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.TEASING_NORMAL;
                    } else if (
                        reelIndex - preceding < 2 &&
                        this._impactScatterCounter >= 2 &&
                        this.stoppedSymbolsArray[reelNo].symbols[symbolNo] !== this.teasingSymbol &&
                        !force
                    ) {
                        this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.TEASING_NOWIN;
                    } else if (force && this.stoppedSymbolsArray[reelNo].symbols[symbolNo] === this.teasingSymbol) {
                        this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.NO_CHANGE;
                    } else {
                        this.symbolsTeasingAttributes[reelNo][symbolNo].action = SymbolTeasingActions.NORMAL;
                    }
                }
            }
        }

        if (reelIndex === this.reelCount - 1) {
            this._impactScatterCounter = 0;
        }

        return this.symbolsTeasingAttributes;
    }

    public isTeasing(reelIndex: number): boolean {
        let count = this.precedingReelsWithSymbols(reelIndex + 1, this.teasingSymbol);

        if (count >= 2 && reelIndex < this.reelCount - 1) {
            return true;
        } else {
            return false;
        }
    }

    //******************************************************************************************************************
    //  REELS TEASING ANIMATIONS
    //******************************************************************************************************************

    /**
     * Start animating teasing layers.
     * OBSOLETE
     * @param reelIndex
     */
    public animateTeasing(reelIndex: number): boolean {
        if (this.teasingEnabled && !this.wildPositions.length) {
            //this.removeTeasing(false);

            if (this.reelsTeasingAttributes[reelIndex + 1] != null) {
                if (this.reelsTeasingAttributes[reelIndex + 1].action == ReelTeasingActions.TEASE) {
                    if (this.elementInstance["background"] != null) {
                        if (this.elementInstance["background"].hasCase("TEASING")) {
                            this.elementInstance["background"].goToCase("TEASING");
                        }
                    }

                    if (this.elementInstance["teasingParticles"] != null) {
                        if (this.elementInstance["teasingParticles"].hasCase("TEASE_REEL_" + (reelIndex + 2))) {
                            this.elementInstance["teasingParticles"].goToCase("TEASE_REEL_" + (reelIndex + 2));
                        }
                    }

                    if (this.elementInstance["teasingReels"] != null) {
                        if (this.elementInstance["teasingReels"].hasCase("TEASE_REEL_" + (reelIndex + 2))) {
                            this.elementInstance["teasingReels"].goToCase("TEASE_REEL_" + (reelIndex + 2));
                        }
                    }

                    if (!this.wasPlayedTeaserSound) {
                        //PlayList.play('SND_BaseFSTeaser');
                        this.wasPlayedTeaserSound = true;
                    }
                } else if (this.reelsTeasingAttributes[reelIndex].action == ReelTeasingActions.SPIN_STOP) {
                    this.removeTeasing(false);
                    return false;
                }
                return true;
            }

            let countSymbolsOnReelsAndRows = this.getCountSymbolsOnReelsAndRows(0, reelIndex, this.teasingSymbol);
            let countSymbolsOnCurrentReel = this.getCountSymbolsOnReelsAndRows(
                reelIndex,
                reelIndex,
                this.teasingSymbol,
            );

            /*
            if (countSymbolsOnCurrentReel) {
                if (countSymbolsOnReelsAndRows > 0 && countSymbolsOnReelsAndRows <=3) {
                    PlayList.play('SND_SymScatterStop01');
                } else if (countSymbolsOnReelsAndRows > 3) {
                    PlayList.play('SND_SymScatterStop03');
                }
            }*/
        } else {
            this.removeTeasing(false);
            return false;
        }
        return false;
    }

    /**
     * Remove teasing animations.
     * In case of enought teasing symbols count win sound is played else fail sound is played.
     *
     * @param {boolean} noWin
     */
    public removeTeasing(noWin: boolean): void {
        if (noWin) {
            PlayList.play("SND_BaseFSTeaserFail");
        }

        if (this.wasPlayedTeaserSound) {
            // PlayList.stop('SND_BaseFSTeaser');

            if (this.countSymbolsOnReelsAndRows > this.minimumSymbolsForTeasing) {
                if (!this.wasPlayedTeaserWinSound) {
                    // PlayList.play('SND_BaseFSTeaserWin');
                    this.wasPlayedTeaserWinSound = true;
                }
            } else {
                if (!this.wasPlayedTeaserFailSound) {
                    PlayList.play("SND_BaseFSTeaserFail");
                    this.wasPlayedTeaserFailSound = true;
                }
            }
        }

        if (this.elementInstance["teasingFront"] != null) {
            if (
                this.elementInstance["teasingFront"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingFront"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingFront"].goToCase("OUTRO");
            }
        }
        /*
        if (this.elementInstance['teasingParticles'] != null) {
            if (this.elementInstance['teasingParticles'].getCurrentCase() !== 'NORMAL' && this.elementInstance['teasingParticles'].getCurrentCase() !== 'OUTRO') {
                this.elementInstance['teasingParticles'].goToCase('OUTRO');
            }
        }*/
    }

    public finishTeasing(reelIndex?: number): void {
        // PlayList.stop('SND_BaseFSTeaser');

        let countSymbolsOnReelsAndRows = this.getCountSymbolsOnReelsAndRows(0, this.reelCount - 1, this.teasingSymbol);
        if (this.wasPlayedTeaserSound || (reelIndex == this.reelCount - 1 && this.teasingEnabledForce)) {
            if (countSymbolsOnReelsAndRows > this.minimumSymbolsForTeasing) {
                // PlayList.play('SND_BaseFSTeaserWin');
            } else {
                this._delayedTeasingFaildSound.start(30);
            }
        }

        super.finishTeasing();

        this.canPlayTeaserSound = false;
        this.wasPlayedTeaserSound = false;

        if (this.elementInstance["background"] != null) {
            if (
                this.elementInstance["background"].getCurrentCase() === "TEASING" &&
                this.elementInstance["background"].hasCase("TEASING_OUTRO")
            ) {
                this.elementInstance["background"].goToCase("TEASING_OUTRO");
            }
        }

        if (this.elementInstance["teasingFront"] != null) {
            if (
                this.elementInstance["teasingFront"].getCurrentCase() !== "NORMAL" &&
                this.elementInstance["teasingFront"].getCurrentCase() !== "OUTRO"
            ) {
                this.elementInstance["teasingFront"].goToCase("OUTRO");
            }
        }

        if (this.elementInstance["teasingParticles"] != null) {
            if (this.elementInstance["teasingParticles"].hasCase("OUTRO")) {
                this.elementInstance["teasingParticles"].goToCase("OUTRO");
            }
        }

        if (this.elementInstance["teasingReels"] != null) {
            if (this.elementInstance["teasingReels"].hasCase("OUTRO")) {
                this.elementInstance["teasingReels"].goToCase("OUTRO");
            }
        }
    }

    public reelStopped(reelIndex?: number): void {
        super.reelStopped(reelIndex);

        this.wildPositions.forEach((wilds) => {
            if (wilds[0] === reelIndex) {
                if (this.elementInstance["expandingWildReel" + wilds[0]].hasCase("SHOWN")) {
                    this.elementInstance["expandingWildReel" + wilds[0]].goToCase("SHOWN");
                }
            }
        });
    }

    public delayedTeasingFaildSound(): void {
        if (!this.force) {
            PlayList.play("SND_BaseFSTeaserFail", 0, true);
            this.wasPlayedTeaserFailSound = true;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/TeasingBonus.ts
 **/